import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useInput, useNotification, useRequestState} from '~/hooks';
import {Col, UiImage, UiText, UiQuestionnaireLayout, UiButton, UiBox, UiSimpleGrid} from '~/components/elements';
import emergencyContraception from '~/assets/images/icons/emergency-contraception.png';
import {RootState} from '~/redux/root-reducer';
import {setNextQuestionnaire, setQuestionnaireAnswer, setUserQuestionnaireId} from '~/redux/questionnaires/slice';
import {EMERGENCY_CONTRACEPTION_KEYS, METHOD_KEYS} from '~/constants/medical-questionnaires';
import {spacing} from '~/utils/theme/spacing';
import {addQuestionnaire} from '~/redux/questionnaires/thunk';
import {requestOK} from '~/utils/thunk-api';
import {unwrapResult} from '@reduxjs/toolkit';
import {useHistory} from 'react-router-dom';
import {getCurrentUserFromStorage} from '~/services/auth';

const Questionnaire7Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const {accessToken: savedToken} = getCurrentUserFromStorage();
  const {addMessage} = useNotification(dispatch);

  const {loading} = useRequestState(addQuestionnaire);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[EMERGENCY_CONTRACEPTION_KEYS.PURCHASE_PREGNANCY_TEST]?.data,
  );

  const medicalQuestionnaireAnswer = useSelector((state: RootState) => state.questionnaires?.collectData);

  const {inputs, setInputs} = useInput({selectedOption: currentAnswer?.selectedOption || ''});

  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const {wpAuthUser} = medicalQuestionnaire;

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === EMERGENCY_CONTRACEPTION_KEYS.PURCHASE_PREGNANCY_TEST);

  const onClickSubmit = async () => {
    const questionnaireAnswer = {
      key: EMERGENCY_CONTRACEPTION_KEYS.PURCHASE_PREGNANCY_TEST,
      index: questionnaire?.index || '',
      data: inputs,
    };
    dispatch(setQuestionnaireAnswer(questionnaireAnswer));

    const resAction = await dispatch(
      addQuestionnaire({
        data: {
          data: {
            ...medicalQuestionnaireAnswer,
            [EMERGENCY_CONTRACEPTION_KEYS.PURCHASE_PREGNANCY_TEST]: {...questionnaireAnswer},
          },
          wpUserId: wpAuthUser?.wpUserId,
          methodKey: METHOD_KEYS.EMERGENCY_CONTRACEPTION,
        },
      }),
    );
    if (requestOK(resAction, addQuestionnaire)) {
      const result = unwrapResult(resAction);
      if (result?.booking) {
        const type = result?.slotTime;
        dispatch(setUserQuestionnaireId({id: result?.medical?.id}));
        history.push(`/appointment?type=${type}&methodKey=${METHOD_KEYS.EMERGENCY_CONTRACEPTION}&token=${savedToken}`);
      }
    }
  };

  return (
    <>
      <UiQuestionnaireLayout
        backIcon
        actions={questionnaire?.actions}
        disableNext={!inputs.selectedOption}
        handleOnNext={onClickSubmit}
        loading={loading}
        checkoutStep={questionnaire?.checkoutStep}
      >
        <Col alignItems="center" textAlign="center" flex={1}>
          <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.mLarge} mt={spacing.medium} />
          <UiText fontSize="lg" fontWeight="bold" mt={spacing.large}>
            {questionnaire?.questions?.default}
          </UiText>
          {questionnaire?.descriptions?.default?.map(i => (
            <UiText key={i} mt={spacing.small}>
              {i}
            </UiText>
          ))}
          <UiBox mt={spacing.small}>
            <UiSimpleGrid columns={2} spacing={5}>
              {questionnaire?.options?.map(value => (
                <UiButton
                  key={`${value.label}-${value.value}`}
                  title={value.label}
                  variant={inputs.selectedOption === value.value ? 'solid' : 'toggle'}
                  onClick={() => setInputs({selectedOption: value.value})}
                />
              ))}
            </UiSimpleGrid>
          </UiBox>
        </Col>
        <UiText fontSize="sm" mt={spacing.small} textAlign="center">
          {questionnaire?.descriptions?.sub}
        </UiText>
      </UiQuestionnaireLayout>
    </>
  );
};

export default Questionnaire7Screen;
